'use strict';

const Base = require('components/Base/Base');

require('./PlatformHeroVideoPopup.less');

const Selectors = {
    el: '.PlatformHeroVideoPopup',
    popupContent: '.PlatformHeroVideoPopup-content',
    btnClose: '.PlatformHeroVideoPopup-closeBtn'
};

module.exports = Base.extend({

    el: Selectors.el,

    events: {
        'click .PlatformHeroVideoPopup-closeBtn': 'сlosePopup'
    },

    initialize: function (options = {}) {
        Base.prototype.initialize.call(this, options);

        this.options = options;
    },

    openPopup: function (videoId) {
        // Add on client to make ability use autoplay from YouTube without YouTube JS API
        let youtubeIframe =
            `<iframe src="https://www.youtube.com/embed/${videoId}?autoplay=1"
                frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen></iframe>`;

        this.$(Selectors.popupContent).html(youtubeIframe);
        this.$el.addClass('isActive');
    },

    сlosePopup: function () {
        this.$(Selectors.popupContent).html('');
        this.$el.removeClass('isActive');
    }
});

